
const SET_RESULTS = (state, payload) => {
  state.results = payload;
}

export default {
  SET_RESULTS
}